export const saveTags = (tags: string[]) => ({
  type: 'SAVE_TAGS',
  payload: tags,
});
